export default __webpack_public_path__ + "static/media/LineInTheSand.f7b167f9.mp3";